import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-amber-500/15 bg-black/50">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-8 sm:flex-row sm:px-6 lg:px-12">
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="لوگوی سکه کازرانی" className="h-8 w-8 rounded mix-blend-screen" />
        <span className="text-sm font-bold text-amber-100">سکه کازرانی</span>
      </div>
      <p className="text-[11px] text-stone-600">© ۱۴۰۵ سکه کازرانی — کلیه حقوق محفوظ است</p>
      <div className="flex items-center gap-4">
        <Link to="/tv" data-testid="footer-tv-link" className="text-[11px] text-amber-500/70 transition-colors hover:text-amber-300">
          حالت تابلوی مغازه
        </Link>
        <Link to="/admin" data-testid="footer-admin-link" className="text-[11px] text-stone-500 transition-colors hover:text-amber-300">
          ورود مدیریت
        </Link>
      </div>
    </div>
  </footer>
);
